import { useMemo } from 'react'
import { ChannelPlayer } from 'player'
import { OperationMasterResult, TaskOperations } from '../../../../types'
import { findOperation } from '../../../../lib/operations'
import { buildDownloadUrl, buildWavesUrl } from '../common/utils'

interface UseChannelsProps {
  mainOperations: TaskOperations[]
  typeOp: 'mastering' | 'denoiser'
  type: 'mastered' | 'denoised'
}

export const useChannels = ({
  type,
  typeOp,
  mainOperations
}: UseChannelsProps): ChannelPlayer[] => {
  return useMemo<ChannelPlayer[]>(() => {
    const files = findOperation(mainOperations, typeOp)?.result
      ?.files as OperationMasterResult['files']

    if (!files) {
      return []
    }

    const stems: string[] = [type, 'original']
    const channels: ChannelPlayer[] = Object.keys(files)
      .filter((id) => stems.includes(id))
      .map((id) => ({
        id,
        bucket: files[id],
        url: buildDownloadUrl(files[id]),
        wavesUrl: buildWavesUrl(files[id])
      }))

    return channels
  }, [mainOperations, typeOp, type])
}
